import { Injectable } from '@angular/core';
import { SmartHttpService } from '@hrra/core';
import { UrlConfigService } from '@hrra/core';
import { UrlConfig, UrlConfigContainer } from 'src/app/core/url-config';
import { CvBoxApplication } from 'src/app/shared/models/cv-box-application-model';
import { JobseekerOwnApplicationListRecord } from 'src/app/shared/models/jobseeker-application-model';
import { JobseekerInviteListViewModel } from '../models/jobseeker-invite-model';
import { JobseekerInviteFilterEnum } from '../models/enums/invite-list-filter-enum';
import { AnnouncementInviteResponseEnum } from '@hrra/common-models';

@Injectable({
  providedIn: 'root'
})
export class JobseekerAppliesService {
  public getApplicationList(page: number, pageSize: number){
    return this.smartHttp.get<ApplicationViewModel>(this.urlService.urlConfig.api.data.jobseekers.applications, {page: page, pageSize: pageSize});
  }

  public getCvBoxApplicationList(page: number, pageSize: number){
    return this.smartHttp.get<CvBoxApplicationViewModel>(this.urlService.urlConfig.api.data.jobseekers.cvBoxApplications, {page: page, pageSize: pageSize});
  }

  public getInviteList(start: number, filter: JobseekerInviteFilterEnum = JobseekerInviteFilterEnum.All){
    return this.smartHttp.post<JobseekerInviteListViewModel>(this.urlService.urlConfig.api.data.jobseekers.inviteList, {start: start, filter: filter});
  }

  public markInviteViewed(inviteId: number){
    return this.smartHttp.post<any>(this.urlService.urlConfig.api.data.jobseekers.inviteView, {InviteId: inviteId});
  }

  public respondToInvite(inviteId: number, responseStatus: AnnouncementInviteResponseEnum){
    return this.smartHttp.post<any>(this.urlService.urlConfig.api.data.jobseekers.inviteRespond, {inviteId: inviteId, ResponseStatus: responseStatus});
  }

  constructor(private smartHttp: SmartHttpService, private urlService: UrlConfigService<UrlConfigContainer>) { }
}


export interface ApplicationViewModel{
  applications: JobseekerOwnApplicationListRecord[];
  pageSize: number;
  totalRecords: number;
} 

export interface CvBoxApplicationViewModel{
  applications: CvBoxApplication[];
  pageSize: number;
  totalRecords: number;
} 